import React from 'react';
import styles from './AboutUs.module.css';
import imgHistory from './../../assets/AboutUsPage/history.png';
import imgProduction from './../../assets/AboutUsPage/production.png';
import imgPersonal from './../../assets/AboutUsPage/personal.png';
import imgDelivery from './../../assets/AboutUsPage/delivery.png';
import imgEco from './../../assets/AboutUsPage/eco.png';
import useTabTitle from '../Hooks/useTabTitle';

const AboutUs = () => {
    useTabTitle('Despre noi')

    const isMobile = (window.innerWidth <= 768) ? true : false;

    return (
        <div className={styles.container}>
            {(!isMobile) ?
                <>
                    <h1 className={styles.title}>Despre noi</h1>
                    <p className={styles.subtitle}>Produse deosebite pentru oameni deosebiți</p>

                    <div className={styles.section}>
                        <div className={styles.image}>
                            <img src={imgHistory} alt="Echipamente Altep" />
                        </div>
                        <div className={styles.textBlock}>
                            <h2 className={styles.heading}>ISTORIE ȘI DEZVOLTARE</h2>
                            <p className={styles.paragraph}>
                                <span className={styles.bold}>Altep-Center</span> este în producția și vânzările de echipamente de încălzire începând cu anul 2008.
                                De la bun început, compania a stabilit în sine ca un producător de încredere responsabil pentru calitatea produselor și angajamentul față de partenerii și clienți.
                                <br /><br />
                                <span className={styles.bold}>Scopul principal al companiei</span> este de a asigura independența energetică și eficiența energetică a țării, confortul și siguranța consumatorilor.
                                Produsele <span className={styles.bold}>Altep-Center</span> sunt concentrate pe satisfacerea nevoilor de aprovizionare cu căldură a instalațiilor industriale, sociale și de stat, gospodăriilor private.
                                <br /><br />
                                Peste 30.000 de clienți corporativi și gospodării au devenit deja clienți ai <span className={styles.bold}>Altep-Center</span>!
                                În prezent, compania oferă clienților săi un avantaj competitiv important: echipamente de cazane de înaltă calitate, folosind tehnologii europene avansate la prețuri accesibile!
                                <span className={styles.bold}>Altep-Center</span> – lider producător de echipamente de centrale în Ucraina!
                            </p>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.textBlock}>
                            <h2 className={styles.heading}>CAPACITATEA DE PRODUCȚIE</h2>
                            <p className={styles.paragraph}>
                                Compania <span className={styles.bold}>Altep-Center</span> are o bază de producție puternică, cu un ciclu de producție inclus.
                                Toate locurile de producție sunt specializate în tipul de produse. Procesul avansat de producție se realizează pe linii moderne automatizate și robotizate.
                                Producerea produselor se realizează prin metoda serială.
                                <br /><br />
                                Echipamentele de înaltă tehnologie cu combustibil solid <span className={styles.bold}>TM „Altep”</span> este o combinație de calitate, fiabilitate și costuri minime de operare.
                                Pentru producția de produse folosim materiale și componente de cea mai înaltă calitate ale producției interne și externe, care au trecut controlul calității interne.
                                <br /><br />
                                Toate produsele <span className={styles.bold}>TM „Altep”</span> sunt certificate, au documentația de autorizare necesară.
                                În procesul de producție, produsele respectă standardele naționale și europene.
                            </p>
                        </div>
                        <div className={styles.image}>
                            <img src={imgProduction} alt="Echipamente Altep Capacitate" />
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.image}>
                            <img src={imgPersonal} alt="Personal calificat Altep" />
                        </div>
                        <div className={styles.textBlock}>
                            <h2 className={styles.heading}>PERSONAL CU ÎNALTĂ CALIFICARE</h2>
                            <p className={styles.paragraph}>
                                Compania <span className={styles.bold}>„Altep-Center”</span> are o echipă de profesioniști cu înaltă calificare, a căror activitate
                                s-a concentrat pe satisfacerea clientului.
                                <br /><br />
                                Echipa Biroului de Proiectare lucrează zilnic pentru îmbunătățirea proiectării, funcționalității și designului cazanelor, precum și pentru a oferi
                                capacitatea de a modifica elementele structurale în funcție de cerințele individuale ale clientului.
                                <br /><br />
                                Echipa de vânzări abordează profesional și cuprinzător nevoile de încălzire ale clientului.
                                Departamentul de aprovizionare lucrează prompt cu furnizorii pentru a asigura un proces de producție fără probleme.
                                <br /><br />
                                Toți angajații companiei urmează în mod regulat o pregătire avansată.
                            </p>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.textBlock}>
                            <h2 className={styles.heading}>COMANDAREA ȘI LIVRAREA PRODUSELOR</h2>
                            <p className={styles.paragraph}>
                                <span className={styles.bold}>„Altep-Center”</span> oferă un sistem convenabil de a comanda și livrarea produselor din Ucraina și în străinătate.
                                <br /><br />
                                Compania are un inventar puternic de produse, care vă permite să îndepliniți comenzile clienților în cel mai scurt timp posibil.
                                Managerii departamentului de vânzări efectuează prompt selecția echipamentelor în funcție de nevoile individuale ale clientului.
                                <br /><br />
                                Serviciul de logistică asigură livrarea produselor într-un mod convenabil pentru dvs. în cel mai scurt timp posibil.
                            </p>
                        </div>
                        <div className={styles.image}>
                            <img src={imgDelivery} alt="Camioane Altep Livrare" />
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.image}>
                            <img src={imgEco} alt="Ecologie și Certificate" />
                        </div>
                        <div className={styles.textBlock}>
                            <h2 className={styles.heading}>ECOLOGIE ȘI CERTIFICATE</h2>
                            <p className={styles.paragraph}>
                                Sănătatea și siguranța consumatorilor este o prioritate principală a Altep Center.
                                În procesul de producție încercăm să respectăm cele mai înalte standarde europene pentru standarde de mediu.
                                Pentru a reduce emisiile nocive în mediul înconjurător, oferim consumatorilor cazane pe bază de combustibil.
                                <br /><br />
                                În fiecare an parcurgem certificarea produsului pentru a confirma nivelul ridicat al calității sale (Declarație de conformitate, certificat de verificare de tip).
                                <br /><br />
                                Compania are toate premisele necesare pentru producția și operarea produselor.
                            </p>
                        </div>
                    </div>

                    <div className={styles.footer}>
                        <div className={styles.offer}>
                            <h3 className={styles.subheading}>OFERIM</h3>
                            <ul>
                                <li>transportul cazanului către client;</li>
                                <li>condiții favorabile pentru reprezentanții noștri.</li>
                            </ul>
                        </div>
                        <div className={styles.guarantee}>
                            <h3 className={styles.subheading}>GARANTĂM</h3>
                            <ul>
                                <li>termene de livrare scurte;</li>
                                <li>garanție și service post-garanție;</li>
                                <li>consultații tehnice;</li>
                                <li>de înaltă calitate și preț bun.</li>
                            </ul>
                        </div>
                    </div>
                </>
                :
                <>
                    <h1 className={styles.title}>Despre noi</h1>
                    <p className={styles.subtitle}>Produse deosebite pentru oameni deosebiți</p>
                    <h2 className={styles.heading}>ISTORIE ȘI DEZVOLTARE</h2>
                    <div className={styles.image}>
                        <img src={imgHistory} alt="Echipamente Altep" />
                    </div>
                    <p className={styles.paragraph}>
                        <span className={styles.bold}>Altep-Center</span> este în producția și vânzările de echipamente de încălzire începând cu anul 2008.
                        De la bun început, compania a stabilit în sine ca un producător de încredere responsabil pentru calitatea produselor și angajamentul față de partenerii și clienți.
                        <br /><br />
                        <span className={styles.bold}>Scopul principal al companiei</span> este de a asigura independența energetică și eficiența energetică a țării, confortul și siguranța consumatorilor.
                        Produsele <span className={styles.bold}>Altep-Center</span> sunt concentrate pe satisfacerea nevoilor de aprovizionare cu căldură a instalațiilor industriale, sociale și de stat, gospodăriilor private.
                        <br /><br />
                        Peste 30.000 de clienți corporativi și gospodării au devenit deja clienți ai <span className={styles.bold}>Altep-Center</span>!
                        În prezent, compania oferă clienților săi un avantaj competitiv important: echipamente de cazane de înaltă calitate, folosind tehnologii europene avansate la prețuri accesibile!
                        <span className={styles.bold}>Altep-Center</span> – lider producător de echipamente de centrale în Ucraina!
                    </p>

                    <h2 className={styles.heading}>CAPACITATEA DE PRODUCȚIE</h2>
                    <div className={styles.image}>
                        <img src={imgProduction} alt="Echipamente Altep Capacitate" />
                    </div>
                    <p className={styles.paragraph}>
                        Compania <span className={styles.bold}>Altep-Center</span> are o bază de producție puternică, cu un ciclu de producție inclus.
                        Toate locurile de producție sunt specializate în tipul de produse. Procesul avansat de producție se realizează pe linii moderne automatizate și robotizate.
                        Producerea produselor se realizează prin metoda serială.
                        <br /><br />
                        Echipamentele de înaltă tehnologie cu combustibil solid <span className={styles.bold}>TM „Altep”</span> este o combinație de calitate, fiabilitate și costuri minime de operare.
                        Pentru producția de produse folosim materiale și componente de cea mai înaltă calitate ale producției interne și externe, care au trecut controlul calității interne.
                        <br /><br />
                        Toate produsele <span className={styles.bold}>TM „Altep”</span> sunt certificate, au documentația de autorizare necesară.
                        În procesul de producție, produsele respectă standardele naționale și europene.
                    </p>

                    <h2 className={styles.heading}>PERSONAL CU ÎNALTĂ CALIFICARE</h2>
                    <div className={styles.image}>
                        <img src={imgPersonal} alt="Personal calificat Altep" />
                    </div>
                    <p className={styles.paragraph}>
                        Compania <span className={styles.bold}>„Altep-Center”</span> are o echipă de profesioniști cu înaltă calificare, a căror activitate
                        s-a concentrat pe satisfacerea clientului.
                        <br /><br />
                        Echipa Biroului de Proiectare lucrează zilnic pentru îmbunătățirea proiectării, funcționalității și designului cazanelor, precum și pentru a oferi
                        capacitatea de a modifica elementele structurale în funcție de cerințele individuale ale clientului.
                        <br /><br />
                        Echipa de vânzări abordează profesional și cuprinzător nevoile de încălzire ale clientului.
                        Departamentul de aprovizionare lucrează prompt cu furnizorii pentru a asigura un proces de producție fără probleme.
                        <br /><br />
                        Toți angajații companiei urmează în mod regulat o pregătire avansată.
                    </p>

                    <h2 className={styles.heading}>COMANDAREA ȘI LIVRAREA PRODUSELOR</h2>
                    <div className={styles.image}>
                        <img src={imgDelivery} alt="Camioane Altep Livrare" />
                    </div>

                    <p className={styles.paragraph}>
                        <span className={styles.bold}>„Altep-Center”</span> oferă un sistem convenabil de a comanda și livrarea produselor din Ucraina și în străinătate.
                        <br /><br />
                        Compania are un inventar puternic de produse, care vă permite să îndepliniți comenzile clienților în cel mai scurt timp posibil.
                        Managerii departamentului de vânzări efectuează prompt selecția echipamentelor în funcție de nevoile individuale ale clientului.
                        <br /><br />
                        Serviciul de logistică asigură livrarea produselor într-un mod convenabil pentru dvs. în cel mai scurt timp posibil.
                    </p>

                    <h2 className={styles.heading}>ECOLOGIE ȘI CERTIFICATE</h2>
                    <div className={styles.image}>
                        <img src={imgEco} alt="Ecologie și Certificate" />
                    </div>
                    <p className={styles.paragraph}>
                        Sănătatea și siguranța consumatorilor este o prioritate principală a Altep Center.
                        În procesul de producție încercăm să respectăm cele mai înalte standarde europene pentru standarde de mediu.
                        Pentru a reduce emisiile nocive în mediul înconjurător, oferim consumatorilor cazane pe bază de combustibil.
                        <br /><br />
                        În fiecare an parcurgem certificarea produsului pentru a confirma nivelul ridicat al calității sale (Declarație de conformitate, certificat de verificare de tip).
                        <br /><br />
                        Compania are toate premisele necesare pentru producția și operarea produselor.
                    </p>

                    <div className={styles.offer}>
                        <h3 className={styles.subheading}>OFERIM</h3>
                        <ul>
                            <li>transportul cazanului către client;</li>
                            <li>condiții favorabile pentru reprezentanții noștri.</li>
                        </ul>
                    </div>

                    <div className={styles.guarantee}>
                        <h3 className={styles.subheading}>GARANTĂM</h3>
                        <ul>
                            <li>termene de livrare scurte;</li>
                            <li>garanție și service post-garanție;</li>
                            <li>consultații tehnice;</li>
                            <li>de înaltă calitate și preț bun.</li>
                        </ul>
                    </div>
                </>}
        </div >
    );
};

export default AboutUs;
